import { HttpClient } from './serviceBase';

class FileService {
    Upload = async (file) =>
        await HttpClient.Upload('/api/file/image', file);
}

export default new FileService();